import React, { useState } from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';
import styles from './styles.module.less';
import BaseLayers from './BaseLayers';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Spin } from 'antd';

import { BASEMAP, LIGHT_TILE_LAYER, OSM_TILE_LAYER } from './constants';

const Map = ({
  children,
  zoom = 13,
  center = [51.505, -0.09],
  className = '',
  loading = false,
  mapRef = null,
  basemap = BASEMAP.OSM,
  showLayerControl = true,
  ...props
}) => {
  const [activeLayer, setActiveLayer] = useState('OpenStreetMap');
  const useLightBasemap = basemap === BASEMAP.CARTO_LIGHT;

  return (
    <MapContainer
      {...props}
      zoom={zoom}
      center={center}
      className={classNames(styles.mapContainer, className)}
      ref={mapRef}
    >
      {useLightBasemap ? (
        <TileLayer
          attribution={LIGHT_TILE_LAYER.attribution}
          url={LIGHT_TILE_LAYER.url}
          subdomains={LIGHT_TILE_LAYER.subdomains}
          maxZoom={LIGHT_TILE_LAYER.maxZoom}
        />
      ) : (
        <>
          <TileLayer
            attribution={OSM_TILE_LAYER.attribution}
            url={OSM_TILE_LAYER.url}
            maxZoom={OSM_TILE_LAYER.maxZoom}
          />
          <BaseLayers
            onActiveLayer={setActiveLayer}
            layer={activeLayer}
            showControl={showLayerControl}
          />
        </>
      )}

      {loading && <Spin />}
      {children}
    </MapContainer>
  );
};

Map.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  zoom: PropTypes.number,
  center: PropTypes.array,
  className: PropTypes.string,
  loading: PropTypes.bool,
  basemap: PropTypes.oneOf(Object.values(BASEMAP)),
  showLayerControl: PropTypes.bool,
};

export default Map;
